import { trace } from "rytm-helpers"

let updateCallback
let collectionPrevTrigger
let collectionNextTrigger
let openObjectCallback
let collectionTotal = 0
let currentIndex = 0
let items = []

export const setCurrentIndex = (ind) => {
  currentIndex = ind
}
export const getCurrentIndex = () => {
  return currentIndex
}
export const setCollectionTotal = (total) => {
  collectionTotal = total
}
export const getCollectionTotal = () => {
  return collectionTotal
}
export const setItems = (elements) => {
  // trace("set nav items", elements.length)
  items = elements
}
export const getItems = () => {
  return items
}
export const updateNav = () => {
  if (updateCallback) {
    // trace ("~NAV: update callback call...")
    updateCallback()
  }
}
export const destroyNavUpdateCallback = () => {
  // trace ("~NAV: destroy update callback")
  updateCallback = null
}
export const setNavUpdateCallback = (callback) => {
  // trace ("~NAV: set update callback")
  updateCallback = callback
}
export const getCollectionPrevTrigger = () => {
  return collectionPrevTrigger
}
export const getCollectionNextTrigger = () => {
  return collectionNextTrigger
}
export const setCollectionPrevTrigger = (trigger) => {
  // trace ("~NAV: set collection PREV trigger", trigger)
  collectionPrevTrigger = trigger
}
export const setCollectionNextTrigger = (trigger) => {
  // trace ("~NAV: set collection NEXT trigger", trigger)
  collectionNextTrigger = trigger
}

export const destroyOpenObjectCallback = (callback) => {
  openObjectCallback = null
}
export const setOpenObjectCallback = (callback) => {
  openObjectCallback = callback
}

export const openPrev = () => {
  // trace ("~NAV: open Prev")
  if (openObjectCallback && collectionPrevTrigger) {
    openObjectCallback(collectionPrevTrigger)
  }
}
export const openNext = () => {
  // trace ("~NAV: open Next")
  if (openObjectCallback && collectionNextTrigger) {
    openObjectCallback(collectionNextTrigger)
  }
}